import { Grid, Menu } from "antd";
import { NAV_TYPE_SIDE, SIDE_NAV_LIGHT } from "constants/ThemeConstant";
import React, { useContext, useState } from "react";

import Cookies from "universal-cookie";
import Icon from "../util-components/Icon";
import IntlMessage from "../util-components/IntlMessage";
import { Link } from "react-router-dom";
import { LogoutOutlined } from "@ant-design/icons";
import { UserContext } from "../../contexts/auth";
import { connect } from "react-redux";
import navigationConfig from "configs/NavigationConfigFranchise";
import navigationConfigFranchisee from "configs/NavigationConfig";
import { onMobileNavToggle } from "redux/actions/Theme";
import { useAuth } from "contexts/useAuth";
import utils from "utils";

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const SideNavContent = (props) => {
  const [openKeys, setOpenKeys] = useState([]);

  const {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    onMobileNavToggle,
  } = props;
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");
  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };

  const { logout } = useContext(UserContext);

  const auth = useAuth();
  const profile = auth.profile;

  const navigationConfigs =
    profile.type === 1 ? navigationConfig : navigationConfigFranchisee;


  const abilities = profile.abilities


  const onOpenChange = (keys) => {


    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);

    if (openKeys.length < 1 || latestOpenKey?.split('-')?.includes('sub') || latestOpenKey?.split('-')?.includes('sub2') || !latestOpenKey) {
      setOpenKeys([...keys.filter(item => !item?.split('-')?.includes('sub') || !item?.split('-')?.includes('sub2'))])
    }
    else setOpenKeys(latestOpenKey ? [latestOpenKey] : []);


  };


  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      mode="inline"
      style={{ height: "100%", borderRight: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={hideGroupTitle ? "hide-group-title" : ""}
    >
      {navigationConfigs.map((menu) =>
        menu.submenu.length > 0 ? (
          <Menu.ItemGroup
            key={menu.key}
            title={setLocale(localization, menu.title)}
          >
            {menu.submenu.map((subMenuFirst) => {

              let formattedAbilities = [...new Set(abilities.map((item) => item?.split('.')[0])), ...new Set(abilities)];

              let firstChildIsShow =
                formattedAbilities.includes(subMenuFirst.key)
                || abilities.includes("*")
                || subMenuFirst.key === '*';



              const isSubmenuChildRendable = (menu) => {
                if (menu?.submenu?.length > 0) {
                  return menu.submenu.some((subMenu) => {



                    return formattedAbilities.includes(subMenu.key) || abilities.includes("*") || subMenu.key?.split('-').includes('global');
                  })
                }
              }

              function hasPermission(permission, allowedPermissions) {
                if (allowedPermissions.includes(permission)) {
                  return true;
                }

                return false;
              }

              function hasSubMenuPermission(menu, allowedPermissions) {
                if (menu.submenu) {
                  for (let subMenu of menu.submenu) {

                    const hasPermissions = subMenu?.permissions?.filter((permission) => {
                      return abilities.includes(permission) || abilities.includes("*");
                    })?.length > 0

                    if (hasPermission(subMenu.key, allowedPermissions) || hasPermissions) {
                      return true;
                    } else if (hasSubMenuPermission(subMenu, allowedPermissions)) {
                      return true;
                    }
                  }
                }

                return false;
              }




              return (hasSubMenuPermission(subMenuFirst, abilities) || firstChildIsShow || isSubmenuChildRendable(subMenuFirst) || subMenuFirst.key?.split('-').includes('global')) ? (
                subMenuFirst.submenu.length > 0 ? (
                  <SubMenu
                    icon={
                      subMenuFirst.icon ? (
                        <Icon type={subMenuFirst?.icon} />
                      ) : null
                    }
                    key={subMenuFirst.key}
                    title={setLocale(localization, subMenuFirst.title)}
                  >
                    {subMenuFirst.submenu.map((subMenuSecond, index) => {

                      const hasPermissions = subMenuSecond?.permissions?.filter((permission) => {
                        return abilities.includes(permission) || abilities.includes("*");
                      })?.length > 0



                      const isInList = formattedAbilities.includes(subMenuSecond.key) || hasPermissions || abilities.includes(subMenuSecond.key) || subMenuSecond.key?.split('-').includes('global') || abilities.includes(subMenuSecond.submenu[index]?.key) || abilities.includes("*")

                      return subMenuSecond.submenu.length > 0 && (hasSubMenuPermission(subMenuSecond, abilities) || isInList || isSubmenuChildRendable(subMenuSecond)) ? (
                        <React.Fragment key={subMenuSecond.key}>
                          <SubMenu
                            icon={
                              subMenuSecond.icon ? (
                                <Icon type={subMenuSecond?.icon} />
                              ) : null
                            }
                            key={subMenuSecond.key + '-sub'}
                            title={setLocale(localization, subMenuSecond.title)}
                          >
                            {subMenuSecond.submenu.map((subMenuThird) => {

                              return (
                                (hasSubMenuPermission(subMenuThird, abilities) || abilities.includes(subMenuThird.key) || abilities.includes("*") || subMenuSecond.key.split('-').includes('global')) && (
                                  subMenuThird.submenu.length > 0 ? (
                                    <>
                                      <SubMenu
                                        icon={
                                          subMenuThird.icon ? (
                                            <Icon type={subMenuThird?.icon} />
                                          ) : null
                                        }
                                        key={subMenuThird.key + '-sub2'}
                                        title={setLocale(localization, subMenuThird.title)}
                                      >
                                        {subMenuThird?.submenu?.map((subMenuFourth) => (
                                          (hasSubMenuPermission(subMenuThird, abilities) || abilities.includes(subMenuFourth.key) || abilities.includes("*")) && (
                                            <Menu.Item key={subMenuFourth.key}>
                                              {subMenuFourth.icon ? (
                                                <Icon type={subMenuFourth?.icon} />
                                              ) : null}
                                              <span>
                                                {setLocale(localization, subMenuFourth.title)}
                                              </span>
                                              <Link
                                                onClick={() => closeMobileNav()}
                                                to={subMenuFourth.path}
                                              />
                                            </Menu.Item>
                                          )
                                        )
                                        )}
                                      </SubMenu>

                                    </>
                                  ) : (
                                    <Menu.Item key={subMenuThird.key + '-sub-2'}>
                                      {subMenuThird.icon ? (
                                        <Icon type={subMenuThird?.icon} />
                                      ) : null}
                                      <span>
                                        {setLocale(localization, subMenuThird.title)}
                                      </span>
                                      <Link
                                        onClick={() => closeMobileNav()}
                                        to={subMenuThird.path}
                                      />
                                    </Menu.Item>
                                  )
                                )
                              )
                            })}
                          </SubMenu>
                        </React.Fragment>
                      ) : (
                        (abilities.includes(subMenuSecond.key) || hasPermissions || abilities.includes("*")) && (
                          <Menu.Item key={subMenuSecond.key}>
                            {subMenuSecond.icon ? (
                              <Icon type={subMenuSecond?.icon} />
                            ) : null}
                            <span>
                              {setLocale(localization, subMenuSecond.title)}
                            </span>
                            <Link
                              onClick={() => closeMobileNav()}
                              to={subMenuSecond.path}
                            />
                          </Menu.Item>
                        )
                      )
                    }
                    )}
                  </SubMenu>
                ) : (
                  <Menu.Item key={subMenuFirst.key}>
                    {subMenuFirst.icon ? (
                      <Icon type={subMenuFirst.icon} />
                    ) : null}
                    <span>{setLocale(localization, subMenuFirst.title)}</span>
                    <Link
                      onClick={() => closeMobileNav()}
                      to={subMenuFirst.path}
                    />
                  </Menu.Item>
                )
              ) : null;
            })}
          </Menu.ItemGroup>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? (
              <Link onClick={() => closeMobileNav()} to={menu.path} />
            ) : null}
          </Menu.Item>
        )
      )}
      <Menu.Item onClick={logout}>
        <Icon type={LogoutOutlined} />
        <span>Sair</span>
      </Menu.Item>
    </Menu>
  );
};

const TopNavContent = (props) => {
  const { topNavColor, localization } = props;
  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }} >
      {navigationConfig.map((menu) =>
        menu.submenu.length > 0 ? (
          <SubMenu
            key={menu.key}
            popupClassName="top-nav-menu"
            title={
              <span>
                {menu.icon ? <Icon type={menu?.icon} /> : null}
                <span style={{
                  wordBreak: 'break-all',
                  whiteSpace: 'normal !important'
                }}>{setLocale(localization, menu.title)}</span>
              </span>
            }
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  popupClassName="top-nav-menu"
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? (
                    <Icon type={subMenuFirst?.icon} />
                  ) : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </SubMenu>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

const mapStateToProps = ({ theme }) => {
  const { sideNavTheme, topNavColor } = theme;
  return { sideNavTheme, topNavColor };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);
